// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___3Zd5a","back":"styles-module__back___2vIg8","created-by":"styles-module__created-by___3IgLw","createdBy":"styles-module__created-by___3IgLw"};